import QRCodeEntityPage from './QRCodeEntityPage'
export default QRCodeEntityPage